export const isInteractiveBlock = (block) => {
    return (
        block.type.startsWith("question_") ||
        block.type === "interactive"
    );
};

export const buildScreens = (fragments = []) => {
    const screens = [];

    for (const fragment of fragments) {
        const blocks = Array.isArray(fragment.blocks)
            ? fragment.blocks.filter(Boolean)
            : [];

        if (blocks.length === 0) continue;

        let currentBlocks = [];
        let hasInteractive = false;

        for (const block of blocks) {
            currentBlocks.push(block);

            if (isInteractiveBlock(block)) {
                hasInteractive = true;

                screens.push({
                    id: `screen_${screens.length + 1}`,
                    fragmentId: fragment.id,
                    blocks: currentBlocks,
                });

                currentBlocks = [];
            }
        }

        // No interactive blocks:
        // the entire fragment is ONE screen.
        if (!hasInteractive) {
            screens.push({
                id: `screen_${screens.length + 1}`,
                fragmentId: fragment.id,
                blocks,
            });
        }
            // If there are blocks after the last interactive block,
        // they form the next screen.
        else if (currentBlocks.length > 0) {
            screens.push({
                id: `screen_${screens.length + 1}`,
                fragmentId: fragment.id,
                blocks: currentBlocks,
            });
        }
    }

    return screens;
};